export default __webpack_public_path__ + "static/media/SWT1860.34I-42294_-25392_0.52f2c7c3.jpg";